export const urls = {
  api: {
    v10: {},
    v20: {},
    internal: {},
  },
  external: {
    docs: () => 'https://confluence.atlassian.com/x/TwlODQ',
    docsBranchingModel: () =>
      'https://confluence.atlassian.com/x/TwlODQ#BranchingaRepository-jirabranchTocreateabranchfromanissueinJiraSoftware',
  },
  ui: {},
};
